import styled from 'styled-components'
import Content from '@signal/layouts/Content'
import { getColorBackgroundSelector } from '@signal/theme/selectors'

export const Wrapper = styled(Content)`
  background: ${getColorBackgroundSelector('paper')};
`
